// JobPostingv2 Events for Logging
// This file contains all event definitions for JobPostingv2 components

import { JPF_SESSION_INFO_KEY } from "../services/constants";

const JOB_POSTING_V2 = "JOB_POSTING_V2";

export const JOBPOSTING_V2_EVENTS = {
  // Unavailable City Request Events
  UNAVAILABLE_CITY_REQUEST: {
    name: "OTHER_CITY_REQUEST",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Benefits Events
  JOB_BENEFITS_SELECTED: {
    name: "JOB_BENEFITS_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_BENEFITS_DESELECTED: {
    name: "JOB_BENEFITS_DESELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_BENEFITS_CUSTOM_ADDED: {
    name: "JOB_BENEFITS_CUSTOM_ADDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Industry Events
  INDUSTRY_SELECTED: {
    name: "INDUSTRY_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  INDUSTRY_DESELECTED: {
    name: "INDUSTRY_DESELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  INDUSTRY_CUSTOM_ADDED: {
    name: "INDUSTRY_CUSTOM_ADDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  INDUSTRY_EXPERIENCE_TOGGLED: {
    name: "INDUSTRY_EXPERIENCE_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Posting Stepper Events
  STEP_CLICKED: {
    name: "STEP_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  PREVIEW_OPENED: {
    name: "PREVIEW_OPENED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  PREVIEW_CLOSED: {
    name: "PREVIEW_CLOSED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  MOBILE_PREVIEW_OPENED: {
    name: "MOBILE_PREVIEW_OPENED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  MOBILE_PREVIEW_CLOSED: {
    name: "MOBILE_PREVIEW_CLOSED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Posting Form Events
  JOB_POST_OPENED: {
    name: "JOB_POST_OPENED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  FORM_INITIALIZED: {
    name: "FORM_INITIALIZED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  STEP_NAVIGATED: {
    name: "STEP_NAVIGATED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_DATA_LOADED: {
    name: "JOB_DATA_LOADED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_EDIT_DETECTION: {
    name: "JOB_EDIT_DETECTION",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Assets Component Events
  ASSET_SELECTED: {
    name: "ASSET_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  ASSET_DESELECTED: {
    name: "ASSET_DESELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  ASSETS_CARD_EXPANDED: {
    name: "ASSETS_CARD_EXPANDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Browser Back Confirm Dialog Events
  BROWSER_BACK_DIALOG_OPENED: {
    name: "BROWSER_BACK_DIALOG_OPENED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  BROWSER_BACK_STAY: {
    name: "BROWSER_BACK_STAY",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  BROWSER_BACK_LEAVE: {
    name: "BROWSER_BACK_LEAVE",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  BROWSER_BACK_DIALOG_DISMISSED: {
    name: "BROWSER_BACK_DIALOG_DISMISSED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Category Change Alert Events
  CATEGORY_CHANGE_ALERT_OPENED: {
    name: "CATEGORY_CHANGE_ALERT_OPENED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  CATEGORY_CHANGE_CONFIRMED: {
    name: "CATEGORY_CHANGE_CONFIRMED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  CATEGORY_CHANGE_CANCELLED: {
    name: "CATEGORY_CHANGE_CANCELLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Client Name Component Events
  CLIENT_NAME_SELECTED: {
    name: "CLIENT_NAME_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  CLIENT_NAME_SEARCHED: {
    name: "CLIENT_NAME_SEARCHED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  CLIENT_CHIP_SELECTED: {
    name: "CLIENT_CHIP_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Communication Preference Events
  ALLOW_CALLS_TOGGLED: {
    name: "ALLOW_CALLS_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  WHATSAPP_UPDATES_TOGGLED: {
    name: "WHATSAPP_UPDATES_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  PHONE_EDIT_CLICKED: {
    name: "PHONE_EDIT_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  OTP_VERIFICATION_STARTED: {
    name: "OTP_VERIFICATION_STARTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Confirmation Events
  SECTION_EDITED: {
    name: "SECTION_EDITED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DESCRIPTION_EXPANDED: {
    name: "DESCRIPTION_EXPANDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Deposit Required Events
  DEPOSIT_REQUIRED_SELECTED: {
    name: "DEPOSIT_REQUIRED_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DEPOSIT_AMOUNT_CHANGED: {
    name: "DEPOSIT_AMOUNT_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DEPOSIT_REASON_SELECTED: {
    name: "DEPOSIT_REASON_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DEPOSIT_TIME_SELECTED: {
    name: "DEPOSIT_TIME_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Distance Events
  DISTANCE_SELECTED: {
    name: "DISTANCE_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Documents Events
  DOCUMENT_SELECTED: {
    name: "DOCUMENT_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DOCUMENT_DESELECTED: {
    name: "DOCUMENT_DESELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DOCUMENTS_CARD_EXPANDED: {
    name: "DOCUMENTS_CARD_EXPANDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Draft Confirmation Events
  DRAFT_CONTINUED: {
    name: "DRAFT_CONTINUED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DRAFT_DISMISSED: {
    name: "DRAFT_DISMISSED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DRAFT_CONFIRMATION_DIALOG_OPENED: {
    name: "DRAFT_CONFIRMATION_DIALOG_OPENED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Draft Reset Banner Events
  DRAFT_RESET_BANNER_SHOWN: {
    name: "DRAFT_RESET_BANNER_SHOWN",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DRAFT_RESET_BANNER_DISMISSED: {
    name: "DRAFT_RESET_BANNER_DISMISSED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  DRAFT_RESET_BANNER_RESET_CLICKED: {
    name: "DRAFT_RESET_BANNER_RESET_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // English Fluency Events
  ENGLISH_FLUENCY_SELECTED: {
    name: "ENGLISH_FLUENCY_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  ENGLISH_FLUENCY_CARD_EXPANDED: {
    name: "ENGLISH_FLUENCY_CARD_EXPANDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Experience Events
  MIN_EXPERIENCE_CHANGED: {
    name: "MIN_EXPERIENCE_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  MAX_EXPERIENCE_CHANGED: {
    name: "MAX_EXPERIENCE_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  FRESHER_TOGGLED: {
    name: "FRESHER_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Famous Location Events
  FAMOUS_CATEGORY_SELECTED: {
    name: "FAMOUS_CATEGORY_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  FAMOUS_LOCATION_SELECTED: {
    name: "FAMOUS_LOCATION_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Gender Events
  GENDER_SELECTED: {
    name: "GENDER_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Interview Address Events
  INTERVIEW_ADDRESS_CHANGED: {
    name: "INTERVIEW_ADDRESS_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Interview Type Events
  INTERVIEW_TYPE_SELECTED: {
    name: "INTERVIEW_TYPE_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Address Same As Company Events
  ADDRESS_SAME_SELECTED: {
    name: "ADDRESS_SAME_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Sticky Footer Events
  BACK_BUTTON_CLICKED: {
    name: "BACK_BUTTON_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  NEXT_BUTTON_CLICKED: {
    name: "NEXT_BUTTON_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_SUBMITTED: {
    name: "JOB_SUBMITTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  PREMIUM_POPUP_SHOWN: {
    name: "PREMIUM_POPUP_SHOWN",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_PLAN_NAVIGATION: {
    name: "JOB_PLAN_NAVIGATION",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_PLAN_SELECTION_PAGE_LANDED: {
    name: "JOB_PLAN_SELECTION_PAGE_LANDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Category Events
  JOB_CATEGORY_SELECTED: {
    name: "JOB_CATEGORY_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job City Events
  JOB_CITY_SELECTED: {
    name: "JOB_CITY_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Description Events
  JOB_DESCRIPTION_CHANGED: {
    name: "JOB_DESCRIPTION_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_DESCRIPTION_TEMPLATE_APPLIED: {
    name: "TEMPLATE_APPLIED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Locality Events
  JOB_LOCALITY_SELECTED: {
    name: "JOB_LOCALITY_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Timings Events
  JOB_TIMINGS_CHANGED: {
    name: "JOB_TIMINGS_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Title Events
  JOB_TITLE_SELECTED: {
    name: "JOB_TITLE_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  JOB_TITLE_TYPED: {
    name: "JOB_TITLE_TYPED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Job Type Events
  JOB_TYPE_SELECTED: {
    name: "JOB_TYPE_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  IS_CONTRACTUAL_TOGGLED: {
    name: "CONTRACTUAL_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Qualification Events
  QUALIFICATION_SELECTED: {
    name: "QUALIFICATION_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Regional Languages Events
  REGIONAL_LANGUAGE_SELECTED: {
    name: "REGIONAL_LANGUAGE_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  REGIONAL_LANGUAGE_DESELECTED: {
    name: "REGIONAL_LANGUAGE_DESELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  REGIONAL_LANGUAGES_CARD_EXPANDED: {
    name: "REGIONAL_LANGUAGES_CARD_EXPANDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Salary Events
  SALARY_CHANGED: {
    name: "SALARY_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  ADD_INCENTIVE_BUTTON_CLICKED: {
    name: "ADD_INCENTIVE_BUTTON_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  INCENTIVE_CHANGED: {
    name: "INCENTIVE_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  TARGET_BASED_TOGGLED: {
    name: "TARGET_BASED_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  PER_PACKET_TOGGLED: {
    name: "PER_PACKET_TOGGLED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Shift Type Events
  SHIFT_TYPE_SELECTED: {
    name: "SHIFT_TYPE_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Skills Events
  SKILL_SELECTED: {
    name: "SKILL_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  SKILL_DESELECTED: {
    name: "SKILL_DESELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  CUSTOM_SKILL_ADDED: {
    name: "CUSTOM_SKILL_ADDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Vacancy Events
  VACANCY_CHANGED: {
    name: "VACANCY_CHANGED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  VACANCY_CHIP_SELECTED: {
    name: "VACANCY_CHIP_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  VACANCY_CHANGED_INCREMENT_BUTTON_CLICKED: {
    name: "VACANCY_CHANGED_INCREMENT_BUTTON_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  VACANCY_CHANGED_DECREMENT_BUTTON_CLICKED: {
    name: "VACANCY_CHANGED_DECREMENT_BUTTON_CLICKED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Working Days Events
  WORKING_DAYS_SELECTED: {
    name: "WORKING_DAYS_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },
  CUSTOM_WORKING_DAYS_ADDED: {
    name: "CUSTOM_WORKING_DAYS_ADDED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  },

  // Work Location Events
  WORK_LOCATION_SELECTED: {
    name: "WORK_LOCATION_SELECTED",
    category: JOB_POSTING_V2,
    [JPF_SESSION_INFO_KEY]: true
  }

  //

  // Future events can be added here
  // JOB_POSTING_STARTED: {
  //   name: "job_posting_started",
  //   category: JOB_POSTING_V2
  // },
  // JOB_POSTING_COMPLETED: {
  //   name: "job_posting_completed",
  //   category: JOB_POSTING_V2
  // }
};

// Export the key for use in LogService
export { JPF_SESSION_INFO_KEY };
